import React, { useEffect, useState } from "react";
import SectionTitleAndDescription from "./SectionTitleAndDescription";
import DegreeSelect from "components/Select/Degree";
import EduFieldSelect from "components/Select/EduField";
import UniversitySelect from "components/Select/University";
import Label from "components/Common/Label/Label";

const EducationComponent = () => {
 
  return (
    <>
      <div className="w-1/4 ">
        <SectionTitleAndDescription
          title="Education"
          isRequiredSection={false}
          isHelpInfoReq={false}
          description="Specify educational background."
        />
      </div>

      <div className="w-3/4 xl:flex grid gap-8 items-center  ">
        <div className="xl:w-6/12 w-full">
          <Label
            labelTitle={"Select school"}
            isHelpIconRequired={false}
          />
          <div className="mt-1.5 SelectProject-input">
            <UniversitySelect></UniversitySelect>
          </div>
        </div>
        <div className="xl:w-6/12 w-full">
          <Label
            labelTitle={"Select field"}
            isHelpIconRequired={false}
          />
          <div className="mt-1.5 SelectProject-input">
            <EduFieldSelect></EduFieldSelect>
          </div>
        </div>
        <div className="xl:w-6/12 w-full">
          <Label
            labelTitle={"Select degree"}
            isHelpIconRequired={false}
          />
          <div className="mt-1.5 SelectProject-input">
            <DegreeSelect></DegreeSelect>
          </div>
        </div>

        
      </div>
    </>
  );
};

export default EducationComponent;
